import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'
// import pave from '../../assets/img/pave.png'
import SearchTicket from '../searchTicket/SearchTicket'
import Footer from '../../components/global/Footer'
import MiniHeader from '../../components/global/MiniHeader'
import { useParams } from 'react-router-dom'
import NoData from '../../components/NoData'
import { errorMessage } from '../../constants/errorMessage'

function Main() {

	const {partner} = useParams()
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])
	return (
		<div className='main'>
            <MiniHeader />
			{(partner) ? <SearchTicket/> : <NoData message={errorMessage?.invalidPartner}/>}
			<Footer/>
		</div>
		
	)
}


Main.propTypes = {
	dispatch: PropTypes.func,
	loader: PropTypes.bool,
	loaderSms: PropTypes.bool,
	loaderDownload: PropTypes.bool,
	ticketDetailsFromProps: PropTypes.object
}

Main.defaulProps = {
	dispatch: noop,
	loader: false,
	ticketDetailsFromProps: {}
}

function mapStateToProps({ userDetailsReducer }) {
	return {
		loader: userDetailsReducer?.loader,
		loaderSms: userDetailsReducer?.loaderSms,
		loaderDownload: userDetailsReducer?.loaderDownload,
	}
}
export default connect(mapStateToProps)(Main)

